import { Dropdown, Menu, Icon } from '@cognite/cogs.js';
import { useState } from 'react';
import styled from 'styled-components/macro';

import { DeleteItemDialog } from './DeleteItemDialog';
import { EditNameDialog } from './EditNameDialog';

export const ItemSettings = ({
  itemType,
  itemName,
  editAvailable,
  deleteAvailable,
  actionType,
  onDelete,
  onRename,
}: {
  itemType: string;
  itemName: string;
  editAvailable: boolean;
  deleteAvailable: boolean;
  actionType: string;
  onDelete: VoidFunction;
  onRename?: (newName: string) => void;
}) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);

  return (
    <>
      {(editAvailable || deleteAvailable) && (
        <Dropdown
          content={
            <Menu>
              <StyledHeader>SETTINGS</StyledHeader>
              {editAvailable ? (
                <Menu.Item>
                  <StyledSettings
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowEditDialog(true);
                    }}
                  >
                    <Icon type="Edit" style={{ verticalAlign: 'middle' }} />
                    <span
                      style={{ verticalAlign: 'middle' }}
                    >{`Edit ${itemType} name`}</span>
                  </StyledSettings>
                </Menu.Item>
              ) : null}
              {deleteAvailable ? (
                <Menu.Item>
                  <StyledSettings
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowDeleteDialog(true);
                    }}
                  >
                    <Icon type="Delete" style={{ verticalAlign: 'middle' }} />
                    <span
                      style={{ verticalAlign: 'middle' }}
                    >{`${actionType} ${itemType}`}</span>
                  </StyledSettings>
                </Menu.Item>
              ) : null}
            </Menu>
          }
        >
          <StyledIcon
            type="EllipsisVertical"
            size={18}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </Dropdown>
      )}

      {/* Needed to wrap in the div with e.stopPropagation(); for avoiding firing event on the card */}
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        aria-hidden="true"
        role="link"
      >
        {deleteAvailable && showDeleteDialog && (
          <DeleteItemDialog
            itemType={itemType}
            onClose={() => setShowDeleteDialog(false)}
            onDelete={onDelete}
            actionType={actionType}
          />
        )}
        {editAvailable && showEditDialog && onRename && (
          <EditNameDialog
            itemName={itemName}
            itemType={itemType}
            onClose={() => setShowEditDialog(false)}
            onRename={(newName: string) => onRename(newName)}
          />
        )}
      </div>
    </>
  );
};

const StyledHeader = styled(Menu.Header)`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
`;

const StyledSettings = styled.div`
  width: 100%;
  text-align: left;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  display: inline-flex;
  height: 2rem;
  cursor: pointer;
  align-items: center;

  &:hover {
    color: var(--cogs-primary);
  }
`;
